import 'core-js/stable';
import MobileMenu from "@/components/MobileMenu";
import "@/components/Dropdown";
import CitySwitcher from "@/components/CitySwitcher";
import "@/components/StatusChecker";

export default class SiteTemplate {
    constructor() {
        new MobileMenu();
        new CitySwitcher();

        this.bind();

        this.legacy();
    }

    bind() {
        $('.js-jivochat-trigger').on('click', (e) => {
            e.preventDefault();

            try {
                window.jivo_api.open();
            } catch {};
        });
    }

    legacy() {
        $('.menu--city-select').on('click', function (e) {
            e.preventDefault();
            var url = $(this).data('ajax-url');
            $.fancybox(url, {
                type: 'ajax',
                padding: 0,
                fitToView: false,
                margin: 10
            });
        });

        $('.left-menu__item--with-submenu').on('click', '.left-menu__link-wrap', function (e) {
            e.preventDefault();
            $(this).closest('.left-menu__item--with-submenu').toggleClass('left-menu__item--with-submenu-hidden');
        });

        $('.page').on('click', '.popup-item__contents-link', function (e) {
            e.preventDefault();
            $(this).addClass('popup-item__contents-link--active');
            $(this).siblings('.popup-item__contents-block').addClass('popup-item__contents-block--active');
        });

        $('.page').on('click', '.tabs__item', function () {
            var $this = $(this);
            var tabIns = $this.closest('.tab-instance');
            if (!$this.hasClass('tabs__item--active')) {

                var tabId = $this.data('tab-id');
                console.log(tabId);
                if (tabId) {
                    tabIns.find('.tabs__item').removeClass('tabs__item--active');
                    $this.addClass('tabs__item--active');
                    tabIns.find('.tab-wrap').removeClass('tab-wrap--active');
                    tabIns.find('.tab-wrap--' + tabId).addClass('tab-wrap--active');
                }

            }
        });

        $('.city-dropdown__close').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.city-dropdown').remove();
            Cookies.set('hidesmallpopup', 'Y', {expires: 30});
        });
        $('.city-dropdown__all-link').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.city-dropdown').remove();
            Cookies.set('hidesmallpopup', 'Y', {expires: 30});
            $('.js-city-switcher-trigger').first().click();
        })
    }
}